module.exports = __webpack_public_path__ + "img/icon_setup_mianrong@2x.6536ff3c.png";